import { render, staticRenderFns } from "./WidgetBody.vue?vue&type=template&id=371940e2&scoped=true&"
import script from "./WidgetBody.vue?vue&type=script&lang=js&"
export * from "./WidgetBody.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBody.vue?vue&type=style&index=0&id=371940e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371940e2",
  null
  
)

export default component.exports